import useSeo from "@/hooks/useSeo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "./components/HeroSection";
import HotTopicsSection from "./components/HotTopicsSection";
import CompareSection from "./components/CompareSection";
import RankingSection from "./components/RankingSection";
import ArticlesSection from "./components/ArticlesSection";
import TrendSection from "./components/TrendSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import { faqs } from "@/mocks/faq";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  useSeo({
    title: "网红明星跨界对比 | 咖位差距有多大 谁更火-咖位观察局",
    description:
      "咖位观察局聚焦网红明星跨界对比，从同框名场面、咖位差距到热度走势，用热度、话题、商业、专业四个维度拆解，带你理性吃瓜看门道，快速掌握圈内真实排位与流量变迁。",
    keywords: "网红明星,网红明星跨界对比,网红明星差距有多大,网红明星谁更火,网红明星咖位对比,同框名场面,热度走势",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: siteInfo.name,
          description: siteInfo.description,
          inLanguage: "zh-CN",
        },
        {
          "@type": "Organization",
          name: siteInfo.name,
          email: siteInfo.email,
          foundingDate: siteInfo.founded,
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.slice(0, 4).map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: { "@type": "Answer", text: item.answer },
          })),
        },
      ],
    },
  });

  return (
    <>
      <SiteHeader transparent />
      <main>
        <HeroSection />
        <HotTopicsSection />
        <CompareSection />
        <RankingSection />
        <ArticlesSection />
        <TrendSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}